import produce from 'immer';

import type { MarketPollingData } from '@swf/sports/types/market';
import removeClosedMarketsFromTemplates from '@swf/sports/utils/removeClosedMarketsFromTemplates';
import updateMarket from '@swf/sports/utils/updateMarket';

import type { MarketsSuccessResponse } from '../model/types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  marketsRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  clear: (): State => produce(defaultState, (draft) => draft),
  marketsLoadSuccess: (state: State, payload: MarketsSuccessResponse): State => ({
    ...payload,
    isLoading: false,
    hasPreloaded: true,
    error: undefined
  }),
  marketsLoadFailure: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: payload
  }),
  marketsUpdated: (state: State, { data: marketUpdates, closed }: MarketPollingData) =>
    typeof state.error === 'undefined'
      ? produce(state, (draft) => {
          // Remove any closed markets from the store
          if (closed.length) removeClosedMarketsFromTemplates(draft, closed);

          // Update the markets with new data
          Object.entries(marketUpdates).forEach(([marketUpdateId, marketUpdate]) => {
            const market = draft.markets[marketUpdateId];

            if (market && marketUpdate) updateMarket(market, marketUpdate);
          });

          return draft;
        })
      : state
};
